import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import isTenantUser from "../../../CustomHook/tenantUser";

export default function SiteAlarmNav(props){
    const { user: profileUser } = useSelector((state) => state.profileReducer);
    const { user: authUser } = useSelector((state) => state.authReducer);
    const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);

    if (tenantUser) {
        return (
            <ul className="dc_nav">
                <li className={`cus-tab ${props.id==2?'active':''}`}><Link to={`/site/${props.site_id}/alarms/rms`}>RMS Alarms</Link></li>
            </ul>
        );
    }

    return (
        <>
         <ul className="dc_nav">
                    <li className={`cus-tab ${props.id==1?'active':''}`}><Link to={`/site/${props.site_id}/alarms`}>ACS Alarms</Link></li>
                    <li className={`cus-tab ${props.id==2?'active':''}`}><Link to={`/site/${props.site_id}/alarms/rms`}>RMS Alarms</Link></li>
                </ul>
        </>
    )
}